<div class="flex flex-col">
  <div
    *ngIf="isReport === true"
    (click)="emitChartToggleSeries({ dataRowId: seriesElement.dataRowId })"
    class="text-s1 mb-5 flex cursor-pointer select-none flex-row items-start text-lg"
  >
    <div class="flex flex-row items-center">
      <m-chevron-right-icon *ngIf="isExpanded === false"></m-chevron-right-icon>
      <m-chevron-down-icon *ngIf="isExpanded === true"></m-chevron-down-icon>

      <div class="ml-2 flex flex-row items-center">
        <span class="text-lg">Series</span>
        <span class="ml-2">-</span>

        <m-row-metric-label
          class="ml-2 mt-1 flex text-base"
          [name]="seriesElement.seriesRowName"
          [isMetric]="seriesElement.isMetric"
          [isAddPrefixRowId]="true"
          [isWrap]="true"
          [rowId]="seriesElement.dataRowId"
          [showMetricsModelName]="seriesElement.showMetricsModelName"
          [showMetricsTimeFieldName]="seriesElement.showMetricsTimeFieldName"
          [partNodeLabel]="seriesElement.partNodeLabel"
          [partFieldLabel]="seriesElement.partFieldLabel"
          [timeNodeLabel]="seriesElement.timeNodeLabel"
          [timeFieldLabel]="seriesElement.timeFieldLabel"
          [topLabel]="seriesElement.topLabel"
        ></m-row-metric-label>
      </div>
    </div>
  </div>

  <div
    *ngIf="isReport === false"
    (click)="emitChartToggleSeries({ dataField: seriesElement.dataField })"
    class="text-s1 mb-5 flex cursor-pointer select-none flex-row items-start text-lg"
  >
    <div class="flex flex-row items-center">
      <m-chevron-right-icon *ngIf="isExpanded === false"></m-chevron-right-icon>
      <m-chevron-down-icon *ngIf="isExpanded === true"></m-chevron-down-icon>

      <div class="ml-2 flex flex-row items-center">
        <span class="text-lg">Series</span>
        <span class="ml-2">-</span>

        <m-field-label
          [column]="seriesElement.field"
          class="ml-2 mt-1 text-base"
        ></m-field-label>
      </div>
    </div>
  </div>

  <div *ngIf="isExpanded === true" class="flex flex-col">
    <div
      class="mb-5 ml-[32px] flex flex-row items-center"
      *ngIf="
        [seriesTypeEnum.Line, seriesTypeEnum.Bar].indexOf(seriesElement.type) >
        -1
      "
    >
      <div class="text-s1 flex h-9 w-[50px] select-none items-center text-base"
        >Type</div
      >

      <!-- <div class="ml-5 flex flex-row items-center justify-start space-x-5">
      <m-chart-line-icon
        class="h-6 w-6 cursor-pointer"
        [ngClass]="{
          'text-m500': seriesElement?.type === seriesTypeEnum.Line,
          'text-s500': seriesElement?.type !== seriesTypeEnum.Line
        }"
        (click)="seriesTypeChange(seriesTypeEnum.Line)"
      ></m-chart-line-icon>

      <m-chart-bar-icon
        class="h-6 w-6 cursor-pointer"
        [ngClass]="{
          'text-m500': seriesElement?.type === seriesTypeEnum.Bar,
          'text-s500': seriesElement?.type !== seriesTypeEnum.Bar
        }"
        (click)="seriesTypeChange(seriesTypeEnum.Bar)"
      ></m-chart-bar-icon>
    </div> -->

      <form [formGroup]="seriesTypeForm" class="ml-5 min-w-[2px] flex-grow">
        <ng-select
          #seriesTypeSelect
          [fixNgSelectBottom]="seriesTypeSelect"
          data-cy="seriesTypeSelect"
          class="chart-type-select w-[150px] select-none text-base focus:outline-none"
          [items]="seriesTypesList"
          [clearable]="false"
          [searchable]="false"
          (change)="seriesTypeChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); seriesTypeSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); seriesTypeSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
          formControlName="seriesType"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="ml-1 flex flex-row items-center justify-start space-x-2"
            >
              <img class="h-6 w-6" [src]="item.iconPath" />
              <div> {{ item.label }} </div>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div
              class="ml-1 flex flex-row items-center justify-start space-x-2"
            >
              <img class="h-6 w-6" [src]="item.iconPath" />
              <div> {{ item.label }} </div>
            </div>
          </ng-template>
        </ng-select>
      </form>
    </div>

    <div
      *ngIf="
        [
          seriesTypeEnum.Line,
          seriesTypeEnum.Bar,
          seriesTypeEnum.Scatter
        ].indexOf(seriesElement.type) > -1
      "
      class="mb-5 ml-[32px] flex flex-row items-center"
    >
      <div class="text-s1 flex h-9 w-[50px] select-none items-center text-base"
        >Y Axis</div
      >

      <form [formGroup]="yAxisIndexForm" class="ml-5 min-w-[2px] flex-grow">
        <ng-select
          [fixNgSelectBottom]="yAxisIndexSelect"
          #yAxisIndexSelect
          data-cy="yAxisIndexSelect"
          class="chart-type-select w-[130px] select-none text-base focus:outline-none"
          [items]="yAxisIndexList"
          [clearable]="false"
          [searchable]="false"
          (change)="yAxisIndexChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); yAxisIndexSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); yAxisIndexSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
          formControlName="yAxisIndex"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="ml-1 flex flex-row items-center justify-start space-x-2"
            >
              <div> {{ item === 0 ? 'Left' : 'Right' }} </div>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div
              class="ml-1 flex flex-row items-center justify-start space-x-2"
            >
              <div> {{ item === 0 ? 'Left' : 'Right' }} </div>
            </div>
          </ng-template>
        </ng-select>
      </form>
    </div>
  </div>
</div>
